import { API, Auth } from 'aws-amplify';
import { SET_REMINDER_PREFERENCES } from '../constants/actionTypes';

export function loadReminderPreferences() {
  return async dispatch => {
    try {
      const init = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        }
      };
      const prefs = await API.get('ReminderPreferencesGateway', '/reminder_preferences', init);
      dispatch({ type: SET_REMINDER_PREFERENCES, payload: prefs });
    } catch (err) {
      // 204 No Content — no prefs saved yet, dispatch null
      dispatch({ type: SET_REMINDER_PREFERENCES, payload: null });
    }
  };
}

export function saveReminderPreferences(prefs) {
  return async dispatch => {
    const init = {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
      },
      body: prefs
    };
    const saved = await API.put('ReminderPreferencesGateway', '/reminder_preferences', init);
    dispatch({ type: SET_REMINDER_PREFERENCES, payload: saved });
  };
}
